module.exports = __webpack_public_path__ + "img/request.c5f2fa9e.svg";